import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  /* All route components are lazy-loaded via dynamic imports for code-splitting */
  routes: [
    {
      path: '/',
      redirect: {
        path: '/accounts/'
      }
    },
    {
      path: '/login/',
      name: 'login',
      meta: {
        title: 'Login'
      },
      component: () => import('../views/client/ClientLogin.vue')
    },
    {
      path: '/accounts/',
      name: 'accounts',
      meta: {
        title: 'Accounts'
      },
      component: () => import('../views/client/ClientAccounts.vue')
    },
    {
      path: '/client/:id',
      name: 'client',
      meta: {
        title: 'Dashboard'
      },
      component: () => import('../views/client/ClientDashboard.vue')
    },
    {
      path: '/admin/client/new/',
      name: 'admin-client-new',
      meta: {
        title: 'Add Client'
      },
      component: () => import('../views/admin/AdminClientNew.vue')
    },
    {
      path: '/admin/client/:id',
      name: 'admin-client-edit',
      meta: {
        title: 'Edit Client'
      },
      component: () => import('../views/admin/AdminClientEdit.vue')
    },
    {
      path: '/admin/client/:id/update/:update',
      name: 'admin-client-update',
      meta: {
        title: 'Add/Edit Update'
      },
      component: () => import('../views/admin/AdminClientUpdate.vue')
    },
    {
      path: '/admin/global/update/:update',
      name: 'admin-global-update',
      meta: {
        title: 'Add/Edit Update'
      },
      component: () => import('../views/admin/AdminClientUpdate.vue')
    },
    {
      path: '/admin/audit/',
      name: 'admin-audit',
      meta: {
        title: 'Audit Logs'
      },
      component: () => import('../views/admin/AdminAudit.vue')
    },
    {
      path: '/admin/notification/',
      name: 'admin-notification',
      meta: {
        title: 'Notification Logs'
      },
      component: () => import('../views/admin/AdminNotification.vue')
    },
    {
      path: '/admin/settings/',
      name: 'admin-settings',
      meta: {
        title: 'Settings'
      },
      component: () => import('../views/admin/AdminSettings.vue')
    },
    {
      path: '/restricted/',
      name: 'restricted',
      meta: {
        title: 'Restricted'
      },
      component: () => import('../views/admin/AdminRestricted.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      meta: {
        title: '404 Not Found'
      },
      component: () => import('../views/client/ClientNotFound.vue')
    }
  ]
})

export default router
